import { Star } from "lucide-react";

/**
 * Estrellas de solo lectura para mostrar una calificación (0–5). Redondea
 * a media estrella. Puro (sin estado) — se usa en el detalle y las tarjetas.
 */
export default function StarRating({
  rating,
  size = 16,
  className = "",
}: {
  rating: number;
  size?: number;
  className?: string;
}) {
  // Redondea a la media estrella más cercana.
  const rounded = Math.round(rating * 2) / 2;
  return (
    <span
      className={`inline-flex items-center gap-0.5 ${className}`}
      aria-label={`${rating.toFixed(1)} de 5 estrellas`}
    >
      {[1, 2, 3, 4, 5].map((i) => {
        const full = rounded >= i;
        const half = !full && rounded >= i - 0.5;
        return (
          <span key={i} className="relative inline-block" style={{ width: size, height: size }}>
            <Star size={size} className="absolute inset-0 text-yolk/30" />
            {(full || half) && (
              <span
                className="absolute inset-0 overflow-hidden"
                style={{ width: half ? size / 2 : size }}
              >
                <Star
                  size={size}
                  className="text-yolk fill-yolk"
                />
              </span>
            )}
          </span>
        );
      })}
    </span>
  );
}
